import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import requests from 'app/requests/Lane/LaneAutoQuotation.requests'
import {
    Lane,
} from 'app/Apps/OrderManagement/Lanes/lanes.types'
import simpleApi from 'app/services/simpleApi'

const useLaneUpdate = ({
    id,
    onSuccess,
}: {
    onSuccess: () => void,
    id: number,
}) => {
    const token = useJWTToken()
    const {
        onError,
    } = useHandleStatusRequest({
        id: 'LaneLogistics',
        title: 'Update Lane',
    })

    return useMutation({
        mutationFn: (data: Lane) => {
            return simpleApi({
                ...requests.updateImplementationDetails({
                    id,
                    data,
                }),
                token,
            })
        },
        onSuccess,
        onError,
    })
}

export default useLaneUpdate
